/* eslint-disable no-unused-vars */
/* eslint-disable no-nested-ternary */
/* eslint-disable eqeqeq */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import 'url-search-params-polyfill';
import { Field } from 'react-form';
import { required } from '../../../utils/form-validation';
import Description from '../../text/Description';
import { isMobileDevice } from '../../../utils/misc';
import Img from '../../Img';

import styles from './teamTennisClubSearch.scss';
import { getApiAxiosInstance } from '../../../utils/network';

class TeamTennisClubSearch extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: false,
            showDropDown: false,
            options: [],
            query: props.defaultValue || '',
            skip: 0,
            searched: false,
        };

        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);

        this.handleOnFocus = this.handleOnFocus.bind(this);
        this.handleKeyUp = this.handleKeyUp.bind(this);
        this.handlePaste = this.handlePaste.bind(this);
        this.fetchSearchResults = this.fetchSearchResults.bind(this);
        this.handleLinkClick = this.handleLinkClick.bind(this);
        this.handleSearchBackClick = this.handleSearchBackClick.bind(this);
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
        if (this.props.query) {
            this.setState({
                query: this.props.query,
            });
        }
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    setWrapperRef(node) {
        this.wrapperRef = node;
    }

    handleClickOutside(event) {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target) && this.state.showDropDown) {
            this.setState({
                showDropDown: false,
            });
        }
    }

    handleOnFocus() {
        if (this.state.query.length > 0) {
            this.setState({
                showDropDown: true,
            });
        }
    }

    handleKeyUp(event) {
        const query = event.target.value;

        if (query.length > 0) {
            if (isMobileDevice()) {
                window.scrollTo(0, 0);
            }
            this.setState({
                isLoading: true,
                showDropDown: true,
                query,
                options: [],
                skip: 0,
            }, () => {
                this.fetchSearchResults();
            });
        } else {
            this.setState({
                query: '',
                options: [],
                skip: 0,
                showDropDown: false,
            });
        }
        if (this.props.onChange) {
            this.props.onChange(query);
        }
    }

    handlePaste(event) {
        const { target } = event;

        setTimeout(() => {
            const query = target.value.trim();
            if (query.length > 0) {
                this.setState({
                    isLoading: true,
                    showDropDown: true,
                    query,
                    options: [],
                    skip: 0,
                }, () => {
                    this.fetchSearchResults();
                });
            } else {
                this.setState({
                    query: '',
                    options: [],
                    showDropDown: false,
                });
            }
            if (this.props.onChange) {
                this.props.onChange(query);
            }
        }, 200);
    }

    fetchSearchResults() {
        const axiosInstance = getApiAxiosInstance();
        const {
            query,
            skip,
        } = this.state;
        const params = new URLSearchParams();
        params.append('query', query);
        params.append('top', 15);
        params.append('skip', skip);

        if (this.props.filter) {
            params.append('filter', this.props.filter);
        }

        if (this.props.clubSearch) {
            params.append('clubSearch', 'true');
        }

        const that = this;
        const { CancelToken } = axios;

        if (query.length > 0) {
            if (that.cancel != undefined) {
                that.cancel();
            }
            axiosInstance.get(`/v2/search${this.props.searchEndPoint}`, {
                cancelToken: new CancelToken(((c) => {
                    that.cancel = c;
                })),
                params,
            }).then((response) => {
                const {
                    hits,
                    // total,
                } = response.data;
                that.setState({
                    options: (skip ? [...that.state.options, ...hits] : hits),
                    isLoading: false,
                    isEnd: hits.length <= 10,
                    skip: skip + 10,
                    searched: true,
                });
            }).catch((error) => {
                console.log(error);
                that.setState({
                    isLoading: false,
                    searched: true,
                });
            });
        } else {
            this.setState({
                isLoading: false,
                showDropDown: false,
                options: [],
                query: '',
                skip: 0,
                searched: true,
            });
        }
    }

    handleLinkClick(club) {
        if (this.props.clearAfterSelect) {
            this.setState({
                query: '',
                showDropDown: false,
            });
        }
        if (this.props.closeAfterSelect) {
            this.setState({
                query: club.name,
                showDropDown: false,
            });
        }
        this.props.handleTeamTennisClubSelect(club);
    }

    handleSearchBackClick() {
        this.setState({
            isLoading: false,
            showDropDown: false,
            options: [],
            query: '',
            skip: 0,
            searched: false,
        });

        if (this.props.handleClubClearClick) {
            this.props.handleClubClearClick();
        }
    }

    render() {
        const renderClub = (club, i) => {
            const { displayName, type, location, name } = club;
            const nameValue = this.props.clubSearch ? name : displayName;
            const descriptionItems = [
                ...(type ? [type] : []),
                ...(location && location.display ? [location.display] : []),
            ];
            return (
                (!this.props.entityId || (this.props.entityId && club.id !== this.props.entityId)) ? (
                    <div onClick={() => this.handleLinkClick(club)} key={`s${i}`}>
                        <div className={`row ${styles.clubSearchDropdownOption}`}>
                            <div className="col-2">
                                <Img
                                    className={styles.clubSearchDropdownOptionImage}
                                    src="/img/v2/icons/icon-avatar-club.svg"
                                />
                            </div>
                            <div className="col-10">
                                <div className={`${styles.name} show-ellipsis`} dangerouslySetInnerHTML={{ __html: nameValue }} />
                                <div className={`${styles.place} show-ellipsis`}>
                                    <Description desc={descriptionItems} />
                                </div>
                            </div>
                        </div>
                    </div>
                ) : null
            );
        };

        const renderDropdown = () => (
            <div className="pb24">
                {this.state.options.length === 0 && !this.state.isLoading && (
                    <div className={styles.clubSearchDropdownNoMatches}>
                        {this.state.searched && 'No Matches Found'}
                    </div>
                )}
                {(this.state.options.length > 0 || this.state.isLoading) && (
                    <div className={styles.clubSearchDropdownOptions}>
                        {this.state.options.map((club, i) => renderClub(club.source, i))}
                        {this.state.isLoading && (
                            <div className={styles.loading}><i className="fas fa-circle-notch fa-spin" />Loading...</div>
                        )}
                    </div>
                )}
            </div>
        );

        return (
            <div className={`${styles.clubSearchContainer} ${styles.lookup} ${this.props.searchContainerClassName ? this.props.searchContainerClassName : ''}`} ref={this.setWrapperRef}>
                <div className={`${styles.clubSearchInputContainer} ${this.state.showDropDown ? styles.showOnTop : ''}`}>
                    {this.state.showDropDown && (
                        <span
                            className={`d-block d-lg-none fas fa-chevron-left ${styles.feedbackLeft}`}
                            onClick={this.handleSearchBackClick}
                        />
                    )}
                    {this.props.label && (
                        <label>{this.props.label}</label>
                    )}
                    <Field
                        query={this.state.query}
                        validate={() => required(this.state.query)}
                        asyncValidate={() => required(this.state.query)}
                        field={'dualMatchOpponent'}
                    >
                        {(fieldApi) => {
                            const { query } = fieldApi;
                            return (
                                <input
                                    type="text"
                                    value={query}
                                    className={`form-control  ${styles.clubSearchInput} ${this.props.className} ${this.state.showDropDown ? 'dropdown-open' : ''}`}
                                    onChange={this.handleKeyUp}
                                    onPaste={this.handlePaste}
                                    onFocus={this.handleOnFocus}
                                    placeholder={this.props.placeholder}
                                />
                            );
                        }}
                    </Field>
                    {this.props.showSearchClearIcon && this.state.query.length > 0 && (
                        <span
                            className={`form-control-feedback fas fa-times-circle ${styles.feedbackRight}`}
                            onClick={this.handleSearchBackClick}
                        />
                    )}
                </div>
                {this.state.showDropDown && (
                    <div className={`${styles.clubSearchDropdownContainer} ${this.props.showInviteSchool ? 'pb60' : ''}`}>
                        {renderDropdown()}
                    </div>
                )}
            </div>
        );
    }
}

function mapDispatchToProps() {
    return {};
}

function mapStateToProps({ auth }) {
    return { auth };
}

export default connect(mapStateToProps, mapDispatchToProps)(TeamTennisClubSearch);
